<template>
    <div>
      <div class="range-slider my-1 flex items-center">
        <img :src="require(`@/assets/${imgPaths[param][0]}.png`)"/>
        <input
          type="range"
          :min="min"
          :max="max"
          :step="step"
        class="form-range w-full appearance-none bg-black rounded slider-thumb outline-none
        cursor-pointer p-0 m-3 mx-4 h-px range-sm overflow-visible"
          v-model="store.params[param]"
        />
        <img :src="require(`@/assets/${imgPaths[param][1]}.png`)"/>
      </div>
    </div>
</template>

<script>
import {store} from '../store'
export default {
    name: "RangeSlider",
    props: ['label','param','min','max', 'step'],
    components: {
    },
    data: ()=>({
        store,
        imgPaths: [
          ['circle8','circle32'],
          ['circle32','star32']
        ]
    })
}
</script>
<style>
.range-slider {
  @apply flex;
}
.form-range::-ms-thumb{
  background:black;
  border: none;
}
.form-range::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background:black;
  border: none;
}
.form-range::-moz-range-thumb {
  background: black;
  border: none;
}

</style>